
const constraints = {
	audio: false,
	video: {
		width: { ideal: 1280 },
		height: { ideal: 1280 },
		facingMode: "environment",
	},
};

export default class CameraUpload {
	static initAll() {
		const cameras = document.querySelectorAll(".camera-upload");

		cameras.forEach((camera) => new CameraUpload(camera));
	}

	constructor(element) {
		this.el = element;
		this.videoEl = this.el.querySelector("video");
		this.canvasEl = this.el.querySelector("canvas");
		this.imgEl = this.el.querySelector("img");
		this.snapBtn = this.el.querySelector(".btn-snap");
		this.clearBtn = this.el.querySelector(".btn-clear");
		this.inputEl = this.el.querySelector("input");
		this.mediaStream = null;

		if (!(this.videoEl || this.canvasEl || this.imgEl || this.snapBtn || this.clearBtn)) return;

		this.switchCamera("user");
		this.snapBtn.addEventListener("click", (e) => {
			e.preventDefault();
			this.takePicture();
		});
		this.clearBtn.addEventListener("click", (e) => {
			e.preventDefault();
			this.clearPhoto();
		});
	}

	async getMediaStream(constraints) {
		try {
			this.mediaStream = await navigator.mediaDevices.getUserMedia(constraints);

			this.videoEl.srcObject = this.mediaStream;
			this.videoEl.onloadedmetadata = (event) => {
				this.videoEl.play();
			};
		} catch (err) {
			console.error(err.message);
		}
	}

	/**
	 * @param {'user'|'environment'} cameraMode
	 */
	async switchCamera(cameraMode) {
		try {
			// stop the current video stream
			if (this.mediaStream != null && this.mediaStream.active) {
				const tracks = this.mediaStream.getVideoTracks();
				tracks.forEach((track) => {
					track.stop();
				});
			}

			// set the video source to null
			this.videoEl.srcObject = null;

			// change "facingMode"
			constraints.video.facingMode = cameraMode;

			// get new media stream
			await this.getMediaStream(constraints);
		} catch (err) {
			console.error(err.message);
			alert(err.message);
		}
	}

	takePicture() {
		let context = this.canvasEl.getContext("2d");

		const height = this.videoEl.videoHeight;
		const width = this.videoEl.videoWidth;

		if (width && height) {
			this.canvasEl.width = width;
			this.canvasEl.height = height;
			context.drawImage(this.videoEl, 0, 0, width, height);
			const data = this.canvasEl.toDataURL("image/png");
			this.imgEl.setAttribute("src", data);

			this.prepareDataTransfer(data);

			this.imgEl.classList.remove("hidden");
			this.clearBtn.classList.remove("hidden");
			this.snapBtn.classList.add("hidden");
			this.videoEl.classList.add("hidden");
		} else {
			this.clearPhoto();
		}
	}

	clearPhoto() {
		let context = this.canvasEl.getContext("2d");

		context.fillStyle = "#AAA";
		context.fillRect(0, 0, this.canvasEl.width, this.canvasEl.height);
		this.imgEl.setAttribute("src", "/svg/avatar_placeholder.svg");

		this.prepareDataTransfer(null);

		this.imgEl.classList.add("hidden");
		this.clearBtn.classList.add("hidden");
		this.snapBtn.classList.remove("hidden");
		this.videoEl.classList.remove("hidden");
	}

	prepareDataTransfer(imageData) {
		if (imageData === null) {
			this.inputEl.files = null;
			this.inputEl.value = null;
			return;
		}

		const uploadFile = new File([this.dataURItoBlob(imageData)], `${Date.now()}.png`, {
			type: 'image/png',
			lastModified: new Date()
		});

		const dataTransfer = new DataTransfer();
		dataTransfer.items.add(uploadFile);
		this.inputEl.files = dataTransfer.files;

		// Help Safari out
		if (this.inputEl.webkitEntries.length) {
			this.inputEl.dataset.file = `${dataTransfer.files[0].name}`;
		}
	}

	dataURItoBlob(dataURI) {
		// convert base64 to raw binary data held in a string
		// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
		var byteString = atob(dataURI.split(',')[1]);
		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);
		var dw = new DataView(ab);
		for (var i = 0; i < byteString.length; i++) {
			dw.setUint8(i, byteString.charCodeAt(i));
		}
		// write the ArrayBuffer to a blob, and you're done
		return new Blob([ab], { type: mimeString });
	}
}
